export function addCheckboxValue({ layer, value }) {
  return {
    ...layer,
    checked: value,
  }
}
